import React from 'react';
import PropTypes from 'prop-types';

const CopyToClipboard = ({
  handleClick,
  fill = '',
  dimension = '',
  className = '',
}) => (
  <svg
    width={dimension || '14px'}
    height={dimension || '14px'}
    viewBox="0 0 14 14"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    onClick={handleClick}
    className={className}
    data-testid="copy-icon"
  >
    <title />
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="Transactions-Payments-01"
        transform="translate(-575.000000, -481.000000)"
      >
        <g id="Group-7" transform="translate(265.000000, 264.000000)">
          <g
            id="back-arrow"
            transform="translate(317.000000, 224.000000) rotate(-360.000000) translate(-317.000000, -224.000000) translate(310.000000, 217.000000)"
          >
            <g id="Group">
              <rect id="Rectangle" x="0" y="0" width="14" height="14" />
              <path
                d="M8.4,2.7776 L2.541,2.7776 C1.57304883,2.77914348 0.788970661,3.56384791 0.7882,4.5318 L0.7882,12.2458 C0.788970661,13.2137521 1.57304883,13.9984565 2.541,14 L8.4,14 C9.36576316,13.9953794 10.1464409,13.2115739 10.1472,12.2458 L10.1472,4.5318 C10.1464409,3.56602608 9.36576316,2.78222063 8.4,2.7776 Z M8.8508,12.2458 C8.8508,12.49477 8.64896997,12.6966 8.4,12.6966 L2.541,12.6966 C2.29257694,12.6958285 2.0916,12.4942243 2.0916,12.2458 L2.0916,4.5318 C2.0916,4.28360323 2.29280323,4.0824 2.541,4.0824 L8.4,4.0824 C8.64842425,4.0824 8.8500285,4.28337694 8.8508,4.5318 L8.8508,12.2458 Z"
                id="Shape"
                fill={fill || 'var(--PRIMARY)'}
                fillRule="nonzero"
              />
              <path
                d="M11.459,0 L6.0494,0 C5.17523226,0.0007718925 4.46677189,0.709232255 4.466,1.5834 C4.48214254,1.93158899 4.76913702,2.20558626 5.1177,2.20558626 C5.46626298,2.20558626 5.75325746,1.93158899 5.7694,1.5834 C5.7694,1.42876027 5.89476027,1.3034 6.0494,1.3034 L11.459,1.3034 C11.7074231,1.3041715 11.9084012,1.50577575 11.9084,1.7542 L11.9084,9.0258 C11.9084,9.18043973 11.7830397,9.3058 11.6284,9.3058 L11.2952,9.3058 C10.9348894,9.3058 10.6428,9.59788943 10.6428,9.9582 C10.6428,10.3185106 10.9348894,10.6106 11.2952,10.6106 L11.6298,10.6106 C12.503421,10.6090568 13.2110296,9.90082198 13.2118,9.0272 L13.2118,1.7542 C13.2110293,0.786247908 12.4269512,0.00154347694 11.459,0 Z"
                id="Path"
                fill={fill || 'var(--PRIMARY)'}
                fillRule="nonzero"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

CopyToClipboard.propTypes = {
  fill: PropTypes.string,
  handleClick: PropTypes.func,
  dimension: PropTypes.string,
  className: PropTypes.string,
};

export default CopyToClipboard;
